export enum MerchantIdentifier {
    DigIn = 1,
    Glovo = 2,
    BoltFood = 3,
    TooGoodToGo = 4,
    Takeaway = 5,
    UberEats = 6,
    AMarmita = 7,
}